<ng-container *ngIf="loaded">
  <app-popup-img-viewer
    [imgKey]="img.key"
    [dataGroupItem]="dataGroupItem"
    [options]="{ thumbs: true, titleFrom: 'Name', modal: false }"
    (closeImgViewer)="onCloseWindow($event)">
  </app-popup-img-viewer>
</ng-container>
